import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { ReportsService } from '../../reports.service'
import { GrossprofitReportsStateModel } from './grossprofit-reports.model'
import { GetGrossProfitByTagSize, GetGrossprofitReports } from './grossprofit-reports.actions'

@State<GrossprofitReportsStateModel>({
  name: 'grossprofitReports'
})
@Injectable()
export class GrossprofitReportsState {
  constructor(private reportsService: ReportsService) {}

  @Selector()
  static reports(state: GrossprofitReportsStateModel) {
    return state.reports
  }

  @Selector()
  static grossProfitByTagSize(state: GrossprofitReportsStateModel) {
    return state.grossProfitByTagSize
  }

  @Action(GetGrossprofitReports)
  getGrossprofitReports(
    ctx: StateContext<GrossprofitReportsStateModel>,
    { payload }: GetGrossprofitReports
  ) {
    return this.reportsService.getGrossprofitReports(payload).pipe(
      tap((res) => {
        ctx.patchState({ reports: res })
      })
    )
  }

  @Action(GetGrossProfitByTagSize)
  getGrossProfitByTagSize(
    ctx: StateContext<GrossprofitReportsStateModel>,
    { payload }: GetGrossProfitByTagSize
  ) {
    return this.reportsService.getGrossProfitByTagSize(payload).pipe(
      tap((res) => {
        ctx.patchState({ grossProfitByTagSize: res })
      })
    )
  }
}
